import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a1a1a] text-white/60 py-12 px-4 text-center text-sm" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <div className="text-white font-serif font-bold text-xl mb-8 flex items-center justify-center gap-2" data-id="element-60">
          <span data-id="element-61">🎵</span> MÚSICA LISTA
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mb-8" data-id="element-62">
          <a href="#" className="hover:text-white transition-colors" data-id="element-63">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-64">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-65">
            Contacto
          </a>
        </div>

        <p data-id="element-66">&copy; 2026 MÚSICA LISTA — Todos los derechos reservados.</p>
      </div>
    </footer>;
}